import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { "aria-label": "breadcrumb" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item active" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb-item active"
}
const _hoisted_5 = {
  key: 1,
  class: "breadcrumb-item active"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", { class: "divider-primary" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("h3", null, _toDisplayString(_ctx.title != null && _ctx.title.length > 0 ? _ctx.title : _ctx.setting.SPP_PAYMENT_TITLE), 1),
    _createVNode("nav", _hoisted_1, [
      _createVNode("ol", _hoisted_2, [
        _createVNode("li", _hoisted_3, _toDisplayString(_ctx.setting.SPP_PAYMENT_SUBTITLE), 1),
        (_ctx.link1)
          ? (_openBlock(), _createBlock("li", _hoisted_4, _toDisplayString(_ctx.link1), 1))
          : _createCommentVNode("", true),
        (_ctx.link2)
          ? (_openBlock(), _createBlock("li", _hoisted_5, _toDisplayString(_ctx.link2), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_6
  ], 64))
}